import { useTranslation } from "react-i18next";
import { alertColumns } from "../../Constants/alertColumns";
import { toDateTime } from "../../Services/string.service";
import EmptyData from "../../components/EmptyData";

const DATE_FIELDS = ["eventDate", "lastUpdateDate"];

export default function AlertGrid({ gridData, onViewDetails }) {
  const { t } = useTranslation();
  const columns = alertColumns(t);

  const renderCell = (field, value) => {
    if (DATE_FIELDS.includes(field)) {
      return value ? toDateTime(value) : "";
    }

    if (field === "location" && value) {
      return (
        <a
          href={`https://maps.google.com/?q=${encodeURIComponent(value)}`}
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: "underline", color: "inherit" }}
        >
          {value}
        </a>
      );
    }

    return value ?? "";
  };

  if (!Array.isArray(gridData) || gridData.length === 0) {
    return <EmptyData />;
  }

  return (
    <div className="card">
      <div className="table-responsive text-nowrap">
        <table className="table table-grid" id="alert-grid">
          <thead>
            <tr>
              <th></th>
              {columns.map(({ field, header }) => (
                <th key={field}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody className="table-border-bottom-0">
            {gridData.map((item, index) => (
              <tr key={item.protocolId ?? index}>
                <td>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => onViewDetails(item)}
                  >
                    {t("ALERTS.DETAILS_BUTTON")}
                  </button>
                </td>
                {columns.map(({ field }) => (
                  <td key={field}>{renderCell(field, item[field])}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
